export default {
  props: ['menuItems', 'showMobileMenu'],
  data() {
    return {
      small: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    epsCartLength() {
      return this.$store.state.eps.cartLength;
    },
    productsCartLength() {
      return this.$store.state.shop.cart.cartLength;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    isBlocked() {
      return !!(
        this.$store.state.user && this.$store.state.user.blocked_at !== null
      );
    },
    showCart() {
      return !!(
        this.isAuthenticated
        && !this.isBlocked
        && (this.epsCartLength || this.productsCartLength)
      );
    },
    newMobileNotifications() {
      return this.$store.state.mobileNotifications.notificationsNew;
    },
    showNotification() {
      return !!(
        this.newMobileNotifications && this.newMobileNotifications.length
      );
    },
    userAvatar() {
      return this.$store.state.user.full_name
        .split(' ')
        .map(x => x[0])
        .join('');
    },
    showPortfolioLock() {
      const status = this.user?.portfolio_status?.status;
      if (!status) {
        return false;
      }
      return (
        status === 'new' || status === 'admin_review' || status === 'blocked'
      );
    },
  },
  methods: {
    getRouteClass(item) {
      return this.$route.name === item.name ? 'is-active' : '';
    },
    emitItemClick(item) {
      if (item.path) {
        this.$router.push(item.path);
      } else if (item.remote) {
        window.open(`${item.remote}`, '_blank');
      }
      this.$emit('toggleMenu', false);
    },
    onResize() {
      this.small = window.innerWidth <= 1024;
      this.userAva = window.innerWidth <= 1024;
      this.smaller = window.innerWidth <= 599;
      this.searchShow = window.innerWidth <= 599;
      this.ToggleDrawerOnResize();
    },
    ToggleDrawerOnResize(brakpoint = 1024) {
      if (window.innerWidth >= brakpoint) {
        this.showMobileMenu && this.$emit('toggleMenu', false);
      }
    },
    UserLogout() {
      console.log('logout');
      this.$store.dispatch('UserLogout');
      this.$router.push('/');
    },
  },
  created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
};
